// extracted by mini-css-extract-plugin
export var chevron = "_cg-2";
export var dropdownItems = "_cg-0";
export var item = "_cg-1";